import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { SendSmsNodeData } from '../../../node-edit.type';
import { CreatePhoneContactDialogComponent } from './components/create-phone-contact-dialog/create-phone-contact-dialog.component';
import { ValidatorsHelpers } from 'src/app/helpers/validators.helpers';
import { OrgUsersSelectComponent } from '../../org-users-select/org-users-select.component';
import { ContactsSelectComponent } from '../../contacts-select/contacts-select.component';
import { allEventVariables } from '@consts/alerts-v2.const';
import { UiTextAreaVariablesComponent } from 'src/app/shared/ui-kit/ui-text-area-variables/ui-text-area-variables.component';

@Component({
  selector: 'edit-send-sms',
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    OrgUsersSelectComponent,
    ContactsSelectComponent,
    UiTextAreaVariablesComponent,
  ],
  templateUrl: './edit-send-sms.component.html',
  styleUrl: './edit-send-sms.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditSendSmsComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditSendSmsComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<SendSmsNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public readonly createPhoneContactDialogComponent = CreatePhoneContactDialogComponent;
  public readonly selectVariablesAutoComplete = allEventVariables;

  public form: UntypedFormGroup = this.fb.group({
    name: [
      this.translateService.instant('FLOW_CHART.NODES.SEND_SMS.NAME'),
      [Validators.required],
    ],
    orgUsersIds: [[]],
    contactsIds: [[]],
    message: ['']
  },
    {
      validators: ValidatorsHelpers.atLeastOneRecipientValidator
    });

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        orgUsersIds: this.selectedNodeForEdit().data.orgUsersIds || [],
        contactsIds: this.selectedNodeForEdit().data.contactsIds || [],
        message: this.selectedNodeForEdit().data.message || '',
      })
    }
  }
}
